import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class InternalOnlyGuard implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser || !currentUser.role) {
      this.router.navigate(['/']);
      return false;
    }
    const role = currentUser.role.toLowerCase();
    if (role.includes('client') || role.includes('employee')) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
